import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrdersService } from 'src/app/core/orders.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-order-details-looked-at-dialog',
  templateUrl: './order-details-looked-at-dialog.component.html',
})
export class OrderDetailsLookedAtDialogComponent {
  looked_at_form_group: FormGroup;
  is_saving_looked_at: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<OrderDetailsLookedAtDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { order_id?: string; store_id?: string; is_looked_at: boolean },
    form_builder: FormBuilder,
    private orders_service: OrdersService,
    private error_service: ErrorService,
  ) {
    this.looked_at_form_group = form_builder.group({ is_looked_at: [data?.is_looked_at ?? false] });
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSaveClick(): void {
    if (!this.data.order_id || !this.data.store_id || this.is_saving_looked_at) return;

    const is_looked_at = this.looked_at_form_group.get('is_looked_at')?.value;
    this.is_saving_looked_at = true;
    this.orders_service.setIsLookedAt(this.data.store_id, this.data.order_id, is_looked_at).subscribe({
      next: () => this.dialog_ref.close({ success: true, is_looked_at }),
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
      },
    });
  }
}
